import { Component, Input } from '@angular/core';
import { LoadingService } from "../../service/loading.service";

@Component({
  selector: 'app-restart-form-modal',
  templateUrl: './restart-form-modal.component.html',
  styleUrls: ['./restart-form-modal.component.scss']
})
export class RestartFormModalComponent {

  @Input("message") message!: string;

  constructor(private loadingService: LoadingService) { }

  restartForm(): void {
    this.loadingService.setLoading(true);
    window.location.reload();
  }
}
